<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <router-link
          class="btn btn-primary"
          to="/AjoutPublication"
        >
          <i class="fa fa-plus-circle"></i>
          Ajouter une publication
        </router-link>
        <!-- <button
          class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
          type="button"
        >
          Exporter
          <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
        </button> -->
      </div>
      <div class="d-flex align-items-center">
        <form class="search-box position-relative me-15" @submit.prevent="rechercher">
          <input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Rechercher une publication"
          />
        </form>

        <!-- FILTRE CATEGORIE -->
        <select
          v-model="categorie"
          class="form-select ms-2"
          @change="rechercher"
        >
          <option value="">Toutes les catégories</option>
          <option value="Textes">Textes</option>
          <option value="Publication enseignant">Publication Enseignant </option>
          <option value="Mémoire">Mémoire</option>
        </select>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
              TITRE
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
              CATEGORIE PUBLICATION
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >AUTEUR
                
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >ANNEE 
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >EDITEUR 
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >CONTENU
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              >Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(p, index) in publications" :key="index">
              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ p.titre }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ p.categoriepublication}}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ p.auteur}}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ p.annepublication  }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ p.editeur  }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ truncateText (p.contenu ,10) }}
              </td>
              <td
                class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0"
              >
              <div class="dropdown">
                  <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                      Actions
                      <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li v-if="checkPermission('EditPublication')">
                      <router-link :to="{ name: 'EditPublication', params: { id: p.id } }" 
                          class="dropdown-item d-flex align-items-center"><i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"
                        ></i>Modifier</router-link>
                    </li>
                    <li>
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        @click="confirmDelete(p.id)"
                      >
                        <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                        Supprimer
                      </a>
                    </li>

                  </ul>
              </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
      </div>
    </div>
  </div>

</template>
<script lang="ts">
import { defineComponent, onMounted, ref  } from "vue";
import AddDepartementModal from "./AddDepartementModal.vue";
import { Publication } from "@/models/Publication";
import ApiService from "@/services/ApiService";
import { format_date, showModal, suppression, error } from "../../utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";
import EditPublication from "./EditPublication.vue";
import axios from "axios";
import Swal from "sweetalert2";

export default defineComponent({
  name: "ListPublication",
  components: {
    PaginationComponent
  },
  setup: () => {

    onMounted(() => {
       getAllPublications(1, limit.value, '', '');
    });
    const categorie = ref('');
    const publications = ref<Array<Publication>>([]);
    const idpublication = ref(0);
    // const departement = ref<Departement>();

    // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        limit.value = limit_;
        // ← passer categorie.value pour ne pas perdre le filtre en cours
        getAllPublications(page_, limit_, searchTerm.value, categorie.value);
      } catch (e) {
        console.error(e);
      }
    };
    
    function truncateText(text: string, maxLength: number): string {
      if (!text) return ''
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text
    }
    // END PAGINATE


  function getAllPublications(page = 1, limi = 10, mot = '', cat = '') {
    return ApiService.get(
      `/publications?page=${page}&limit=${limi}&mot=${mot}&categorie=${encodeURIComponent(cat)}&`
      //                                                              ↑ encodeURIComponent pour "Publication enseignant" avec espace
    )
    .then(({ data }) => {
      publications.value = data.data.data;
      totalPages.value = data.data.totalPages;
      limit.value = data.data.limit;
      totalElements.value = data.data.totalElements;
    })
    .catch(({ response }) => {
      error(response?.data?.message);
    });
  }

    function rechercher() {
      getAllPublications(1, limit.value, searchTerm.value, categorie.value);
    }

    
    function moddifier(EditPublication:Publication) {
      idpublication.value = EditPublication.id;
    }

    function showModalEdite(model){
      showModal(model);
      idpublication.value=0;
    }
    
    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }
   
const deletePublication = async (id: number) => {
  try {
    await axios.delete(`/publi/${id}`);
    alert("Publication supprimée avec succès ");
    // recharge la liste
  } catch (error) {
    console.error(error);
    alert("Erreur lors de la suppression ");
  }
};

const confirmDelete = async (id: number) => {
  const result = await Swal.fire({
    title: "Suppression",
    text: "Voulez-vous vraiment supprimer cette publication ?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Oui, supprimer",
    cancelButtonText: "Annuler",
  });

  if (!result.isConfirmed) return;

  try {
    await ApiService.delete(`/publi/${id}`);

    //  Supprimer l'élément du tableau
    publications.value = publications.value.filter(
      (p) => p.id !== id
    );

    Swal.fire({
      title: "Supprimé !",
      text: "La publication a été supprimée avec succès.",
      icon: "success",
      timer: 3000,
      toast: true,
      position: "top-end",
      showConfirmButton: false,
    });
  } catch (e) {
    Swal.fire({
      title: "Erreur",
      text: "Erreur lors de la suppression de la publication",
      icon: "error",
    });
  }
};


    return {suppression,
      checkPermission,
     publications,
    format_date,
    getAllPublications,
    idpublication,
    moddifier,
    showModalEdite,
    page, 
    totalPages,
    limit,
    totalElements,
    handlePaginate,
    searchTerm,
    rechercher,
    confirmDelete,
    truncateText,
    categorie
     };
  },

 
});
</script>